import { DashboardDepartment } from './db-department.model';
import { DashboardUser } from './db-user.model';

export enum CollectionsPlan {
  CONNECT = 'connect',
  GROWTH = 'growth',
}

export enum EmailCampaignsPlan {
  TRIAL = 'trial',
  CONNECT = 'connect',
  GROWTH = 'growth',
  LAUNCH = 'launch',
}

export const CorporationPlan = {
  TRIAL: 'trial',
  CONNECT: 'connect',
  GROWTH: 'growth',
  LAUNCH: 'launch',
} as const;

export type CorporationPlan = (typeof CorporationPlan)[keyof typeof CorporationPlan];

export enum DashboardRole {
  EDITOR = 'editor',
  VIEWER = 'viewer',
  CREDENTIAL_ISSUER = 'credential_issuer',
}

export interface DashboardIssuer {
  user: DashboardUser;
  department: DashboardDepartment;
  permissions: DashboardIssuerPermissions;
  stripe_customer_id: string;
  phone_number: number;
  agreed_to_recommendations: boolean;
}

export interface DepartmentSecuritySettings {
  mfa_enabled: boolean;
  meta?: {
    mfa_configured: number;
    mfa_not_configured: number;
    mfa_reset_requests: number;
  };
}

export const ISSUER_PERMISSION_KIND = {
  ACCOUNT_WIDE: 'account-wide',
  DEPARTMENT_SPECIFIC: 'department-specific',
} as const;

export type IssuerPermissionKind =
  (typeof ISSUER_PERMISSION_KIND)[keyof typeof ISSUER_PERMISSION_KIND];

export const ISSUER_ACCESS_LEVEL = {
  ORGANIZATION_ADMIN: 'organization_admin',
  DEPARTMENT_ADMIN: 'department_admin',
  TEAM_MEMBER: 'team_member',
  DEVELOPER: 'developer',
} as const;

export type IssuerAccessLevel = (typeof ISSUER_ACCESS_LEVEL)[keyof typeof ISSUER_ACCESS_LEVEL];

export interface DashboardIssuerPermissions {
  team: boolean;
  groups: boolean;
  view: boolean;
  //TODO(Manuel) remove string type in future refactor of roles and permissions
  role: string | DashboardRole;
  group_ids: any[];
  verified: boolean;
  directory: boolean;
  analytics: boolean;
  emails: boolean;
  credential_attributes: boolean;
  designs: boolean;
  api: boolean;
  settings: boolean;
  created_org: boolean;
  spotlight_directory: boolean;
  pathways: boolean;
  admin: boolean;
  switch_department: boolean;
  kind?: IssuerPermissionKind;
  access_level?: IssuerAccessLevel;
  manage_dept_admins_and_devs?: boolean;
  analytics_email?: boolean;
}

export type DashboardIssuerPermissionName = keyof DashboardIssuerPermissions;
